<template>
  <div style="background-color: #f5f6f8; padding: 20px; min-height: 100vh; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
    <div style="background-color: #ffffff; border-radius: 4px; padding: 12px 20px; margin-bottom: 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); border: 1px solid #e5e7eb; display: flex; justify-content: space-between; align-items: center;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="#555">
          <path d="M4 4h5v5H4V4zm7 0h5v5h-5V4zm7 0h5v5h-5V4zM4 11h5v5H4v-5zm7 0h5v5h-5v-5zm7 0h5v5h-5v-5zM4 18h5v5H4v-5zm7 0h5v5h-5v-5zm7 0h5v5h-5v-5z"/>
        </svg>
        <span style="font-weight: 700; font-size: 15px; color: #444; letter-spacing: 0.5px; text-transform: uppercase;">COLLECTIONS RECORD</span>
      </div>
      <v-btn 
        variant="flat" 
        style="background-color: #800080 !important; color: #ffffff !important; border-radius: 4px !important;" 
        @click="goBack"
      >
        CLOSE
      </v-btn>
    </div>

    <div style="background-color: #ffffff; border-radius: 4px; padding: 24px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); border: 1px solid #e5e7eb;">
      <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap;">
        <div style="display: flex; gap: 24px; flex-wrap: wrap; align-items: flex-start;">
          <div v-if="!userImage" style="width: 72px; height: 72px; border-radius: 50%; background-color: #ffffff; border: 1px solid #d1d5db; display: flex; align-items: center; justify-content: center;">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="#9ca3af">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
          </div>
          <div v-else style="width: 72px; height: 72px; border-radius: 50%; overflow: hidden; border: 1px solid #d1d5db;">
            <img :src="imageSrc" style="width: 100%; height: 100%; object-fit: cover;" alt="User avatar">
          </div>

          <div style="display: flex; flex-direction: column; gap: 8px; padding-top: 4px;">
            <div style="font-size: 14px; color: #6b7280; font-weight: 600;">
              Receipt ID: <span style="font-weight: 400; color: #111827; margin-left: 4px;">{{ receiptData.receipt_id || 'N/A' }}</span>
            </div>
            <div style="font-size: 14px; color: #6b7280; font-weight: 600;">
              Payment Method: <span style="font-weight: 400; color: #111827; margin-left: 4px;">{{ receiptData.payment_method || 'N/A' }}</span>
            </div>
            <div style="display: flex; gap: 10px; flex-wrap: wrap; margin-top: 4px;">
              <span :style="{
                backgroundColor: receiptData.payment_status === 'PAID' ? '#f0fdf4' : (receiptData.payment_status === 'OVERDUE' ? '#fee2e2' : '#fef3c7'),
                color: receiptData.payment_status === 'PAID' ? '#166534' : (receiptData.payment_status === 'OVERDUE' ? '#991b1b' : '#92400e'),
                padding: '4px 12px',
                borderRadius: '9999px',
                fontSize: '11px',
                fontWeight: '600',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                border: receiptData.payment_status === 'PAID' ? '1px solid #86efac' : (receiptData.payment_status === 'OVERDUE' ? '1px solid #fecaca' : '1px solid #fcd34d')
              }">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
                PAYMENT STATUS - {{ receiptData.payment_status || 'N/A' }}
              </span>
              <span :style="{
                backgroundColor: receiptData.receipt_status === 'Full_Payment' ? '#f0fdf4' : '#fef3c7',
                color: receiptData.receipt_status === 'Full_Payment' ? '#166534' : '#92400e',
                padding: '4px 12px',
                borderRadius: '9999px',
                fontSize: '11px',
                fontWeight: '600',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                border: receiptData.receipt_status === 'Full_Payment' ? '1px solid #86efac' : '1px solid #fcd34d'
              }">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
                RECEIPT STATUS - {{ receiptData.receipt_status || 'N/A' }}
              </span>
            </div>
          </div>
          <!-- Overdue Information (if applicable) -->
          <div v-if="receiptData.overdue_reason && receiptData.overdue_reason !== '-'" style="margin-top: 20px; padding: 16px; background-color: #fef3c7; border-radius: 4px; border: 1px solid #fcd34d;">
            <div style="font-size: 12px; color: #92400e; margin-bottom: 8px; font-weight: 600;">Overdue Information</div>
            <div style="font-size: 13px; color: #78350f;">Reason: {{ receiptData.overdue_reason }}</div>
            <div style="font-size: 13px; color: #78350f; margin-top: 4px;">Approval Status: {{ receiptData.overdue_approval_status }}</div>
          </div>
        </div>

        <button v-if="permissions.delete" @click="confirmDelete" style="background: #ffffff; border: 1px solid #fca5a5; border-radius: 4px; padding: 8px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #dc2626; transition: all 0.2s;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
          </svg>
        </button>
      </div>

      <hr style="margin: 24px 0; border: none; border-top: 1px solid #f3f4f6;">

      <!-- Receipt Summary Section with Sales Rep Info -->
      <div style="margin-bottom: 32px; background-color: #f9fafb; padding: 20px; border-radius: 4px; border: 1px solid #e5e7eb;">
        <div style="font-weight: 700; font-size: 14px; color: #374151; margin-bottom: 16px;">RECEIPT SUMMARY</div>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 20px;">
          <div>
            <div style="font-size: 12px; color: #6b7280; margin-bottom: 4px;">Collection Amount</div>
            <div style="font-size: 18px; font-weight: 700; color: #111827;">LKR {{ formatNumber(receiptData.collect_total_amount) }}</div>
          </div>
          <div>
            <div style="font-size: 12px; color: #6b7280; margin-bottom: 4px;">Sales Representative</div>
            <div style="font-size: 11px; color: #9ca3af; margin-top: 2px;">Code: {{ salesRepCode || 'N/A' }}</div>
          </div>
          <div>
            <div style="font-size: 12px; color: #6b7280; margin-bottom: 4px;">Created Date</div>
            <div style="font-size: 14px; color: #374151;">{{ formatDate(receiptData.created_at) }}</div>
          </div>
          <div>
            <div style="font-size: 12px; color: #6b7280; margin-bottom: 4px;">Last Updated</div>
            <div style="font-size: 14px; color: #374151;">{{ formatDate(receiptData.updated_at) }}</div>
          </div>
        </div>
      </div>

      <!-- Overdue Approval Details Section -->
       <div v-if="isOverdueApprovalVisible" style="margin-bottom: 32px; background-color: #fffbeb; padding: 20px; border-radius: 4px; border: 2px solid #fcd34d;">
          <div style="font-weight: 700; font-size: 14px; color: #b45309; margin-bottom: 16px; display: flex; align-items: center; gap: 8px;">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="#f59e0b">
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
          </svg>
          OVERDUE APPROVAL STAGES
        </div>

        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 16px;">
          <div 
            v-for="stage in receiptData.overdue_stage" 
            :key="stage"
            :style="{
              backgroundColor: getApprovalStatusColor(stage).bg,
              borderLeft: `4px solid ${getApprovalStatusColor(stage).border}`,
              padding: '16px',
              borderRadius: '4px',
              border: '1px solid #fcd34d'
            }"
          >
            <!-- Stage Name Header -->
            <div style="font-weight: 600; color: #b45309; margin-bottom: 12px; font-size: 13px;">
              {{ getStageName(stage) }}
            </div>

            <!-- Approval Details (if available) -->
            <div v-if="getApprovalForStage(stage)">
              <!-- Status Badge -->
              <div style="margin-bottom: 8px;">
                <span style="font-size: 11px; color: #92400e; font-weight: 600; text-transform: uppercase;">Status</span>
                <div style="display: flex; align-items: center; gap: 8px; margin-top: 4px;">
                  <span 
                    :style="{
                      backgroundColor: getApprovalForStage(stage).status === 'APPROVED' ? '#dcfce7' : '#fef3c7',
                      color: getApprovalForStage(stage).status === 'APPROVED' ? '#166534' : '#92400e',
                      padding: '4px 12px',
                      borderRadius: '12px',
                      fontSize: '11px',
                      fontWeight: '600',
                      display: 'inline-block'
                    }"
                  >
                    {{ getApprovalForStage(stage).status }}
                  </span>
                </div>
              </div>

              <!-- Approver Info (only if APPROVED) -->
              <div v-if="getApprovalForStage(stage).status === 'APPROVED'" style="margin-bottom: 8px; padding-top: 12px; border-top: 1px solid #fcd34d;">
                <div style="font-size: 11px; color: #92400e; font-weight: 600; margin-bottom: 4px;">APPROVED BY</div>
                <div v-if="getApprovalForStage(stage).approved_by" style="font-size: 13px; font-weight: 500; color: #78350f;">
                  {{ getApprovalForStage(stage).approved_by.name }}
                  <span style="font-size: 11px; color: #92400e;">({{ getApprovalForStage(stage).approved_by.user_code }})</span>
                </div>
              </div>

              <!-- Approval Date (only if APPROVED) -->
              <div v-if="getApprovalForStage(stage).status === 'APPROVED' && getApprovalForStage(stage).approved_at" style="margin-bottom: 8px;">
                <div style="font-size: 11px; color: #92400e; font-weight: 600; margin-bottom: 4px;">APPROVED DATE</div>
                <div style="font-size: 13px; font-weight: 500; color: #78350f;">
                  {{ formatDate(getApprovalForStage(stage).approved_at) }}
                </div>
              </div>

              <!-- Approval Comment (only if APPROVED and exists) -->
              <div v-if="getApprovalForStage(stage).status === 'APPROVED' && getApprovalForStage(stage).comment" style="margin-top: 12px; padding-top: 12px; border-top: 1px solid #fcd34d;">
                <div style="font-size: 11px; color: #92400e; font-weight: 600; margin-bottom: 4px;">APPROVAL NOTE</div>
                <div style="font-size: 12px; color: #78350f; line-height: 1.5; font-style: italic;">
                  "{{ getApprovalForStage(stage).comment }}"
                </div>
              </div>
            </div>

            <!-- Awaiting Approval -->
            <div v-else style="color: #92400e; font-size: 12px; font-style: italic;">
              ⏳ Awaiting approval
            </div>
          </div>
        </div>
      </div>

      <div style="display: flex; gap: 32px; flex-wrap: wrap;">
        <div style="flex: 1; min-width: 300px;">
          <v-row>
           <v-col cols="12" xs="12" sm="12" md="6" lg="6">
             <!-- <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Dealer Name</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">{{ currentItem.name || 'N/A' }}</div>
          </div> -->

          <!-- <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Dealer No</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">{{ currentItem.customer_no || 'N/A' }}</div>
          </div> -->

          <!-- NEW: Discount Posting Group Display -->
          <!-- <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Discount Posting Group</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">
              {{ currentItem.discount_posting_group || 'N/A' }}
            </div>
          </div> -->
           </v-col>
          </v-row>
        </div>

        <div style="flex: 1; min-width: 300px;"></div>
      </div>

      <!-- Timeline Section - Only Overdue -->
      <v-col cols="12" md="4" style="padding-left: 0; margin-bottom: 32px;"></v-col>

      <!-- Data Table Section -->
      <v-card-text style="margin-top: 32px; padding: 0;">
        <div style="margin-bottom: 16px;">
          <div style="font-weight: 700; font-size: 14px; color: #374151; margin-bottom: 12px;">RECEIPT ITEMS</div>
          <v-text-field
            v-model="search"
            label="Search"
            prepend-inner-icon="mdi-magnify"
            dense
            outlined
            hide-details
            style="max-width: 300px;"
          />
        </div>
        <v-data-table
          :headers="headers"
          :items="filteredItems"
          :items-per-page="itemsPerPage"
          :search="search"
          density="comfortable"
          class="custom_table_normal"
          hide-default-footer
        >
          <template v-slot:[`item.dealer`]="{ item }">
            <div class="dealer-cell">
              <div class="dealer-name">{{ item.name || item.dealer }}</div>
              <div class="reg-number">
                Reg num: <span>{{ item.regNumber || item.customer_no }}</span>
              </div>
            </div>
          </template>

          <template v-slot:[`item.discount_posting_group`]="{ item }">
            <div style="font-size: 12px; padding: 4px 0;">
              {{ item.discount_posting_group || '-' }}
            </div>
          </template>

          <template v-slot:[`item.amount`]="{ item }">
            <div style="font-size: 13px; font-weight: 500; color: #059669;">
              LKR {{ formatNumber(item.amount) }}
            </div>
          </template>

          <template v-slot:[`item.remaining_amount`]="{ item }">
            <div style="font-size: 13px; font-weight: 500; color: #059669;">
              LKR {{ formatNumber(item.remaining_amount) }}
            </div>
          </template>

          <template v-slot:[`item.assigned_amount`]="{ item }">
            <div style="font-size: 13px; font-weight: 500; color: #059669;">
              LKR {{ formatNumber(item.assigned_amount) }}
            </div>
          </template>

          <template v-slot:[`item.actual_remaining_amount`]="{ item }">
            <div style="font-size: 13px; font-weight: 500; color: #059669;">
              LKR {{ formatNumber(item.actual_remaining_amount) }}
            </div>
          </template>

          <template v-slot:[`item.change_remaining_amount`]="{ item }">
            <div style="font-size: 13px; font-weight: 500; color: #059669;">
              LKR {{ formatNumber(item.change_remaining_amount) }}
            </div>
          </template>

          <template v-slot:[`item.change_assigned_amount`]="{ item }">
            <div style="font-size: 13px; font-weight: 500; color: #059669;">
              LKR {{ formatNumber(item.change_assigned_amount) }}
            </div>
          </template>

          <template v-slot:[`item.change_actual_remaining_amount`]="{ item }">
            <div style="font-size: 13px; font-weight: 500; color: #059669;">
              LKR {{ formatNumber(item.change_actual_remaining_amount) }}
            </div>
          </template>

          <template v-slot:[`item.cash_amount`]="{ item }">
            <div style="font-size: 13px; font-weight: 500; color: #059669;">
              LKR {{ formatNumber(item.cash_amount) }}
            </div>
          </template>

          <template v-slot:[`item.cheque_amount`]="{ item }">
            <div style="font-size: 13px; font-weight: 500; color: #059669;">
              <div v-for="(amount, index) in parseJSONArray(item.cheque_amount)" :key="index">
                LKR {{ formatNumber(amount) }}
              </div>
              <div v-if="!parseJSONArray(item.cheque_amount).length">-</div>
            </div>
          </template>

          <template v-slot:[`item.cheque_number`]="{ item }">
            <div style="font-size: 12px;">
              <div v-for="(cheque, index) in parseJSONArray(item.cheque_number)" :key="index">
                {{ cheque }}
              </div>
              <div v-if="!parseJSONArray(item.cheque_number).length">-</div>
            </div>
          </template>

          <template v-slot:[`item.cheque_date`]="{ item }">
            <div style="font-size: 12px;">
              <div v-for="(date, index) in parseJSONArray(item.cheque_date)" :key="index">
                {{ formatDateString(date) }}
              </div>
              <div v-if="!parseJSONArray(item.cheque_date).length">-</div>
            </div>
          </template>

          <template v-slot:[`item.bank_name`]="{ item }">
            <div style="font-size: 12px;">
              <div v-for="(bank, index) in parseJSONArray(item.bank_name)" :key="index">
                {{ bank }}
              </div>
              <div v-if="!parseJSONArray(item.bank_name).length">-</div>
            </div>
          </template>

          <!-- Cheque Image Column with clickable images -->
          <template v-slot:[`item.cheque_image`]="{ item }">
            <div style="display: flex; gap: 8px; flex-wrap: wrap;">
              <div 
                v-for="(image, idx) in parseJSONArray(item.cheque_image)" 
                :key="idx"
                @click="openImageViewer(image)"
                style="cursor: pointer; width: 40px; height: 40px; border: 1px solid #e5e7eb; border-radius: 4px; overflow: hidden; background: #f9fafb; display: flex; align-items: center; justify-content: center;"
              >
                <img 
                  :src="getImageUrl(image)" 
                  style="width: 100%; height: 100%; object-fit: cover;" 
                  :alt="'Cheque Image ' + (idx+1)"
                  @error="handleImageError"
                >
              </div>
              <div v-if="!parseJSONArray(item.cheque_image).length">-</div>
            </div>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <span :style="{
              backgroundColor: item.status === 'Full_Payment' ? '#f0fdf4' : '#fef3c7',
              color: item.status === 'Full_Payment' ? '#166534' : '#92400e',
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '11px',
              fontWeight: '600',
              display: 'inline-block'
            }">
              {{ item.status || 'N/A' }}
            </span>
          </template>

          <!-- Overdue Count Column - Only shown if payment_status is OVERDUE -->
          <template v-slot:[`item.overdue_count`]="{ item }">
            <div v-if="receiptData.payment_status === 'OVERDUE'" style="text-align: center;">
              <span :style="{
                backgroundColor: '#fee2e2',
                color: '#991b1b',
                padding: '4px 10px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: '700',
                display: 'inline-block',
                border: '1px solid #fecaca'
              }">
                {{ item.overdue_count || 0 }} days
              </span>
            </div>
            <div v-else style="text-align: center; color: #9ca3af; font-size: 12px;">
              —
            </div>
          </template>
        </v-data-table>
      </v-card-text>

      <!-- Images Section - Dynamically handles all images (image1, image2, image3, etc.) -->
      <div v-if="hasAnyImages" style="margin-top: 32px; padding-top: 24px; border-top: 1px solid #e5e7eb;">
        <div style="font-weight: 700; font-size: 14px; color: #374151; margin-bottom: 16px;">ATTACHMENTS</div>
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <div 
            v-for="(image, index) in imageList" 
            :key="index" 
            style="flex: 1; min-width: 200px; max-width: 300px;"
          >
            <label style="display: block; font-size: 12px; color: #6b7280; margin-bottom: 8px;">Image {{ index + 1 }}</label>
            <img 
              :src="getImageUrl(image)" 
              style="width: 100%; max-height: 200px; object-fit: cover; border-radius: 4px; border: 1px solid #e5e7eb; cursor: pointer;" 
              :alt="'Receipt Image ' + (index + 1)" 
              @click="openImageViewer(image)"
              @error="handleImageError"
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Confirmation Dialog -->
    <div v-if="deleteDialog" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000;">
      <div style="background-color: white; border-radius: 4px; width: 400px; max-width: 90%; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
        <div style="padding: 16px; background-color: #f9fafb; border-top-left-radius: 4px; border-top-right-radius: 4px; border-bottom: 1px solid #e5e7eb; display: flex; align-items: center; justify-content: space-between;">
          <span style="font-weight: 700; font-size: 14px; color: #374151;">DELETE COLLECTION DATA</span>
          <button @click="deleteDialog = false" style="background: none; border: none; cursor: pointer; font-size: 20px; color: #6b7280;">&times;</button>
        </div>
        <div style="padding: 24px;">
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 15px;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#f59e0b">
              <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
            </svg>
            <span style="font-weight: 600; color: #dc2626; font-size: 15px;">Do you want to delete this collection record?</span>
          </div>
          <p style="font-size: 13px; color: #4b5563; margin-bottom: 24px; line-height: 1.5;">This collection record will be deleted immediately. Once deleted, it can no longer be used for any purpose.</p>
          <hr style="margin: 16px 0; border: none; border-top: 1px solid #e5e7eb;">
          <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 20px;">
            <button @click="deleteDialog = false" style="padding: 8px 16px; background: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; font-size: 13px; font-weight: 600; color: #4b5563; cursor: pointer;">CANCEL</button>
            <button @click="deleteItem" style="padding: 8px 16px; background-color: #dc2626; color: white; border: none; border-radius: 4px; font-size: 13px; font-weight: 600; cursor: pointer;">DELETE</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Image Viewer Modal -->
    <div v-if="imageViewerVisible" class="image-viewer-overlay" @click="closeImageViewer">
      <div class="image-viewer-container" @click.stop>
        <button class="image-viewer-close" @click="closeImageViewer">&times;</button>
        <img :src="currentViewerImage" class="image-viewer-img" alt="Full size image">
        <div class="image-viewer-controls">
          <button class="image-viewer-btn" @click="downloadCurrentImage">Download</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { EventBus } from "@/plugins/event-bus";
import { getPermissions } from "@/plugins/permissions";

export default {
  name: "Total_Collections_View",
  data() {
    return {
      activeTab: 'cash',
      deleteDialog: false,
      search: '',
      itemsPerPage: 10,
      
      receiptId: null,
      userId: null,
      selectedItemIndex: 0,
      
      agentName: 'Loading...',
      mobileNumber: 'Loading...',
      userType: 'SALES REP',
      userImage: null,
      
      receipts: [], // For timeline data
      
      receiptData: {
        id: null,
        receipt_id: null,
        payment_method: null,
        payment_status: null,
        collect_total_amount: null,
        receipt_status: null,
        cheque_number: null,
        cheque_amount: null,
        cheque_date: null,
        bank_name: null,
        branch_name: null,
        overdue_reason: null,
        overdue_approval_status: null,
        image1: null,
        image2: null,
        image3: null,
        created_at: null,
        updated_at: null,
        overdue: false,
        overdue_stage: [],
        approval_details: null,
        items: [],
        saleRep_name: null,
        saleRep_userCode: null,
        salesperson_code: null,
        overdue_count: null  // Added overdue_count field
      },
      
      // Computed properties for sales rep info
      salesRepName: 'N/A',
      salesRepCode: 'N/A',
      
      permissions: {},
      
      // Image viewer state
      imageViewerVisible: false,
      currentViewerImage: '',
      
      // Updated headers - moved overdue_count next to collection amount (cash_amount), and cheque_number next to cheque_date
      headers: [
        { title: 'DEALER', key: 'dealer', sortable: true },
        { title: 'DISCOUNT POSTING GROUP', key: 'discount_posting_group', sortable: true },
        { title: 'DOCUMENT TYPE', key: 'document_type', sortable: true },
        { title: 'DOCUMENT NO', key: 'document_no', sortable: true },
        { title: 'POSTING DATE', key: 'posting_date', sortable: true },
        { title: 'AMOUNT (LKR)', key: 'amount', sortable: true },
        { title: 'REMAINING (LKR)', key: 'remaining_amount', sortable: true },
        { title: 'ASSIGNED (LKR)', key: 'assigned_amount', sortable: true },
        { title: 'ACTUAL REMAINING', key: 'actual_remaining_amount', sortable: true },
        { title: 'COLLECTION AMOUNT (LKR)', key: 'cash_amount', sortable: true },
        { title: 'OVERDUE COUNT', key: 'overdue_count', sortable: true },  // Moved next to collection amount
        { title: 'CHEQUE NUMBER', key: 'cheque_number', sortable: true },
        { title: 'CHEQUE AMOUNT (LKR)', key: 'cheque_amount', sortable: true },
        { title: 'CHEQUE DATE', key: 'cheque_date', sortable: true },
        { title: 'BANK NAME', key: 'bank_name', sortable: true },
        { title: 'CHEQUE IMAGE', key: 'cheque_image', sortable: false },
        { title: '', key: '', sortable: false },
        { title: 'SYSTEM REMAINING AMOUNT', key: 'change_remaining_amount', sortable: true },
        { title: 'CHANGE ASSIGNED', key: 'change_assigned_amount', sortable: true },
        { title: 'CHANGE ACTUAL REMAINING', key: 'change_actual_remaining_amount', sortable: true },
        { title: 'STATUS', key: 'status', sortable: true },
      ],
    };
  },

  computed: {
    imageSrc() {
      if (this.userImage) {
        return `${process.env.VUE_APP_API_BASE_URL}/SFA/public/${this.userImage}`;
      }
      return '';
    },
    
    currentItem() {
      if (this.receiptData.items && this.receiptData.items.length > 0) {
        return this.receiptData.items[this.selectedItemIndex] || {};
      }
      return {};
    },

    filteredItems() {
      if (!this.receiptData.items || !this.receiptData.items.length) return [];
      
      if (!this.search) return this.receiptData.items;
      
      const searchLower = this.search.toLowerCase();
      return this.receiptData.items.filter(item => {
        return (
          (item.name && item.name.toLowerCase().includes(searchLower)) ||
          (item.dealer && item.dealer.toLowerCase().includes(searchLower)) ||
          (item.document_no && item.document_no.toLowerCase().includes(searchLower)) ||
          (item.customer_no && item.customer_no.toLowerCase().includes(searchLower)) ||
          (item.discount_posting_group && item.discount_posting_group.toLowerCase().includes(searchLower))
        );
      });
    },

    // Filter only overdue receipts for timeline
    overdueReceipts() {
      if (!this.receipts || !this.receipts.length) return [];
      return this.receipts.filter(receipt => receipt.payment_status === 'OVERDUE');
    },

    /**
     * Get all images dynamically
     * Collects image1, image2, image3, etc. that have non-null values
     */
    imageList() {
      const images = [];
      // Check for image1, image2, image3, image4, etc. (up to image10 to be safe)
      for (let i = 1; i <= 10; i++) {
        const imageKey = `image${i}`;
        if (this.receiptData[imageKey] && this.receiptData[imageKey] !== null && this.receiptData[imageKey] !== '') {
          images.push(this.receiptData[imageKey]);
        }
      }
      return images;
    },

    /**
     * Check if there are any images to display
     */
    hasAnyImages() {
      return this.imageList.length > 0;
    },

    isOverdueApprovalVisible() {
        return this.receiptData.payment_status === 'OVERDUE'
            && this.receiptData.overdue
            && this.receiptData.overdue_stage
            && this.receiptData.overdue_stage.length > 0;
    },
  },

  methods: {
    /**
     * Extract sales rep info from items array
     */
    extractSalesRepInfo() {
      if (this.receiptData.items && this.receiptData.items.length > 0) {
        // Get the first item that has salesperson_code
        const itemWithSalesRep = this.receiptData.items.find(item => item.salesperson_code);
        
        if (itemWithSalesRep) {
          this.salesRepCode = itemWithSalesRep.salesperson_code || 'N/A';
          // If you have sales rep name in the items, you can set it here
          // this.salesRepName = itemWithSalesRep.salesperson_name || 'N/A';
        } else {
          this.salesRepCode = 'N/A';
        }
        
        // Also try to get from receiptData level if available
        if (this.receiptData.saleRep_name) {
          this.salesRepName = this.receiptData.saleRep_name;
        }
        
        if (this.receiptData.salesperson_code) {
          this.salesRepCode = this.receiptData.salesperson_code;
        }
      } else {
        // If no items, try to get from receiptData level
        this.salesRepName = this.receiptData.saleRep_name || 'N/A';
        this.salesRepCode = this.receiptData.salesperson_code || 'N/A';
      }
      
      console.log("Sales Rep Info - Name:", this.salesRepName, "Code:", this.salesRepCode);
    },

    /**
     * Open image viewer modal
     */
    openImageViewer(imagePath) {
      if (imagePath) {
        this.currentViewerImage = this.getImageUrl(imagePath);
        this.imageViewerVisible = true;
        // Prevent body scrolling when modal is open
        document.body.style.overflow = 'hidden';
      }
    },

    /**
     * Close image viewer modal
     */
    closeImageViewer() {
      this.imageViewerVisible = false;
      this.currentViewerImage = '';
      // Restore body scrolling
      document.body.style.overflow = '';
    },

    /**
     * Download current image
     */
    downloadCurrentImage() {
      if (this.currentViewerImage) {
        const link = document.createElement('a');
        link.href = this.currentViewerImage;
        link.download = `cheque_image_${Date.now()}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    /**
     * Handle image loading error
     */
    handleImageError(event) {
      event.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="%239ca3af"%3E%3Cpath d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/%3E%3C/svg%3E';
      event.target.style.objectFit = 'contain';
    },

    /**
     * Get approval details for a specific stage
     */
    getApprovalForStage(stage) {
      if (!this.receiptData.approval_details || !Array.isArray(this.receiptData.approval_details)) {
        return null;
      }
      return this.receiptData.approval_details.find(approval => approval.stage === stage);
    },

    /**
     * Get readable stage name from stage code
     */
    getStageName(stage) {
      const stageNames = {
        'AREA_MANAGER': 'Area Manager Approval',
        'REGIONAL_MANAGER': 'Regional Manager Approval',
        'SALES_MANAGER': 'Sales Manager Approval',
      };
      return stageNames[stage] || stage;
    },

    /**
     * Get background color based on approval status
     */
    getApprovalStatusColor(stage) {
      const approval = this.getApprovalForStage(stage);
      if (!approval) {
        return { bg: '#fefce8', border: '#eab308' };
      }
      if (approval.status === 'APPROVED') {
        return { bg: '#f0fdf4', border: '#22c55e' };
      }
      return { bg: '#fef3c7', border: '#eab308' };
    },

    parseJSONArray(value) {
      if (!value) return [];
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch (e) {
        return [value];
      }
    },

    formatNumber(value) {
      if (!value && value !== 0) return '0.00';
      const num = parseFloat(value);
      if (isNaN(num)) return '0.00';
      return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },

    formatDateString(dateString) {
      if (!dateString) return 'N/A';
      // Handle dates with backslashes like "05\/04\/2026"
      const cleanDate = dateString.replace(/\\/g, '');
      const date = new Date(cleanDate);
      if (isNaN(date.getTime())) return cleanDate;
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },

    getImageUrl(imagePath) {
      if (!imagePath) return '';
      if (imagePath.startsWith('http')) return imagePath;
      return `${process.env.VUE_APP_IMAGE_URL}${imagePath}`;
    },

    /**
     * Go back with source tracking
     * Checks if we came from pending reversals, overdue page, approved overdue page, notify page, etc. and returns accordingly
     */
    goBack() {
      // Check if we came from notify collections page
      const returnFromNotify = sessionStorage.getItem('return_from_notify');
      
      if (returnFromNotify === 'true') {
        // Clear the stored value and go back to notify collections
        sessionStorage.removeItem('return_from_notify');
        this.$router.push('/CollectionNotify');
        return;
      }
      
      // Check if we came from overdue collections page
      const returnFromOverdue = sessionStorage.getItem('return_from_overdue');
      
      if (returnFromOverdue === 'true') {
        // Clear the stored value and go back to overdue collections
        sessionStorage.removeItem('return_from_overdue');
        this.$router.push('/overdue-collections');
        return;
      }
      
      // Check if we came from approved overdue collections page
      const returnFromOverdueApproved = sessionStorage.getItem('return_from_overdue_approved');
      
      if (returnFromOverdueApproved === 'true') {
        // Clear the stored value and go back to approved overdue collections
        sessionStorage.removeItem('return_from_overdue_approved');
        this.$router.push('/approved-overdues');
        return;
      }
      
      // Check which source we came from
      const returnToPending = sessionStorage.getItem('return_to_pending_reversals');
      const returnToApproved = sessionStorage.getItem('return_to_approved_reversals');
      const returnToSalesManagement = sessionStorage.getItem('return_to_sales_management');
      
      if (returnToPending === 'true') {
          // Clear the stored value and go back to pending reversals
          sessionStorage.removeItem('return_to_pending_reversals');
          this.$router.push('/pending-reversals');
      } else if (returnToApproved === 'true') {
          // Clear the stored value and go back to approved reversals
          sessionStorage.removeItem('return_to_approved_reversals');
          this.$router.push('/approved-reversals');
      } else if (returnToSalesManagement === 'true') {
          // Clear the stored value and go back to sales management
          sessionStorage.removeItem('return_to_sales_management');
          this.$router.push('/sales-management');
      } else {
          // Default behavior - go back to total collections list
          this.$router.push('/total-collections');
      }
    },

    confirmDelete() {
      this.deleteDialog = true;
    },

    deleteItem() {
      const token = localStorage.getItem('token');
      const id = this.receiptData?.id || this.receiptId;

      axios.delete(`${process.env.VUE_APP_API_BASE_URL}/api/receipt/${id}?userId=${this.userId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(() => {
        this.deleteDialog = false;
        EventBus.emit('collectionsRecodeManagementButtonClick2');
        this.goBack();
      })
      .catch(error => {
        console.error("There was an error deleting the receipt!", error);
        alert('Failed to delete collection record');
      });
    },

    updateSelectedLeads() {
      // Handle selected leads update
      console.log('Selected leads updated');
    },

    fetchReceiptData() {
      const token = localStorage.getItem('token');
      const id = this.receiptId;
      const userId = this.userId;

      if (!id) {
        console.error('No receipt ID provided');
        this.agentName = 'Error: No ID provided';
        return;
      }

      // API call to get receipt data by ID
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/receipt/ReceiptId/${id}`, {
        params: { userId: userId },
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        console.log("Receipt API Response:", response.data);
        if (response.data.success && response.data.data) {
          this.receiptData = response.data.data;
          
          // Extract sales rep info from the response
          this.extractSalesRepInfo();
          
          // Log all images found
          console.log("📸 Images found:", this.imageList);
          
          // Log sales rep info
          console.log("👤 Sales Rep:", {
            name: this.salesRepName,
            code: this.salesRepCode
          });
          
          // Log approval details if available
          if (this.receiptData.approval_details) {
            console.log("✅ Approval Details:", this.receiptData.approval_details);
          }
          
          // Log overdue information
          if (this.receiptData.payment_status === 'OVERDUE') {
            console.log("⚠️ This receipt is OVERDUE! Count:", this.receiptData.overdue_count, "Days:", this.receiptData.overdue_days);
          } else {
            console.log("✅ This receipt is NOT overdue. Payment status:", this.receiptData.payment_status);
          }
          
          // Add additional properties for table functionality if needed
          if (this.receiptData.items && this.receiptData.items.length > 0) {
            this.receiptData.items.forEach(item => {
              // Initialize additional properties for table interactions
              item.selected = item.selected || false;
              item.active = item.active || false;
              item.dealer = item.name; // Map name to dealer for table display
              
              // Ensure overdue_count is available at item level (from backend response)
              // Each item in the response already has its own overdue_count field
              
              // Ensure cheque_image is parsed correctly
              if (item.cheque_image && typeof item.cheque_image === 'string') {
                try {
                  item.cheque_image_parsed = JSON.parse(item.cheque_image);
                } catch (e) {
                  item.cheque_image_parsed = [item.cheque_image];
                }
              } else if (item.cheque_image && Array.isArray(item.cheque_image)) {
                item.cheque_image_parsed = item.cheque_image;
              } else {
                item.cheque_image_parsed = [];
              }
            });
            
            // Set agent info from the first item if available
            const firstItem = this.receiptData.items[0];
            this.agentName = firstItem.name || 'N/A';
            this.mobileNumber = firstItem.customer_no || 'N/A';
            this.userType = firstItem.document_type === 'Invoice' ? 'INVOICE' : 'SALES REP';
          } else {
            this.agentName = 'N/A';
            this.mobileNumber = 'N/A';
          }
        } else {
          console.error('Invalid API response structure');
          this.agentName = 'Error: Invalid response';
        }
      })
      .catch(error => {
        console.error("Error fetching receipt data:", error);
        this.agentName = 'Error loading data';
        this.mobileNumber = 'Error loading data';
      });
    },

    // Fetch receipts for timeline
    fetchReceipts() {
      const token = localStorage.getItem('token');
      const userId = this.userId;

      axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/receipts`, {
        params: { userId: userId },
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response.data.success && response.data.data) {
          this.receipts = response.data.data;
        }
      })
      .catch(error => {
        console.error("Error fetching receipts:", error);
      });
    }
  },
  
  created() {
    this.receiptId = this.$route.params.id;
    this.userId = localStorage.getItem('userId');
    this.fetchReceiptData();
    this.fetchReceipts(); // Fetch receipts for timeline
  },

  mounted() {
    const dashboardId = 6;
    this.permissions = getPermissions(dashboardId);
  },

  // Replaced deprecated beforeDestroy with beforeUnmount
  beforeUnmount() {
    // Ensure body overflow is restored if modal is open when component is destroyed
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>
.custom_table_normal {
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.dealer-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dealer-name {
  font-weight: 600;
  color: #111827;
  font-size: 13px;
}

.reg-number {
  font-size: 11px;
  color: #6b7280;
}

.reg-number span {
  font-weight: 500;
  color: #374151;
}

/* Image Viewer Modal Styles */
.image-viewer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  cursor: pointer;
}

.image-viewer-container {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  background-color: #1a1a1a;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 20px 35px -8px rgba(0, 0, 0, 0.5);
  cursor: default;
}

.image-viewer-img {
  max-width: calc(90vw - 40px);
  max-height: calc(90vh - 100px);
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

.image-viewer-close {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 32px;
  color: #ffffff;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
  z-index: 10;
}

.image-viewer-close:hover {
  opacity: 1;
}

.image-viewer-controls {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
}

.image-viewer-btn {
  padding: 8px 20px;
  background-color: #800080;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.image-viewer-btn:hover {
  background-color: #6a006a;
}

/* Vuetify table overrides */
.v-data-table {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.v-data-table th {
  background-color: #f9fafb !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  color: #374151 !important;
  border-bottom: 1px solid #e5e7eb !important;
}

.v-data-table td {
  font-size: 13px !important;
  color: #111827 !important;
  border-bottom: 1px solid #f3f4f6 !important;
}

.v-data-table tbody tr:hover {
  background-color: #f9fafb !important;
}

/* Timeline custom styles */
.custom_card_box {
  border-radius: 8px;
}

.history-top-title {
  margin-bottom: 8px;
}

.text-subtitle-1 {
  font-size: 0.875rem !important;
  font-weight: 600 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}
</style>